import { pdf } from '@react-pdf/renderer';
import QuotePDF from 'views/reviewQuote/pdf';
import { Providers } from './constants';
import { getCoverages, getFinanceDetails } from './calculationUtils';

function getCoverwhaleCalculation(quote, feeless) {
  if (
    !quote.coverages ||
    typeof quote.coverages !== 'object' ||
    !quote.premiumFinanceDetails.downPayment
  ) {
    return { coverages: null, financialDetails: null };
  }
  const mappedCoverages = getCoverages(quote.coverages);
  const financialDetails = getFinanceDetails(quote, feeless);

  const coverages = {
    ...mappedCoverages,
    towingLaborStorage: quote?.towingLaborStorage,
    waiverSubrogation: quote?.waiverSubrogation,
    UIIAintermodal: quote?.UIIAintermodal,
    primaryNoncontributoryAL: quote?.primaryNoncontributoryAL,
    primaryNoncontributoryTGL: quote?.primaryNoncontributoryTGL,
    trailerInterchange: quote?.trailerInterchange,
    commoditiesRefrigeration: quote?.commoditiesRefrigeration,
  };

  return {
    coverages,
    financialDetails,
  };
}

function getProgressiveCalculation(quote, feeless) {
  return {};
}

class QuoteUtils {
  calculate = (quote, provider, feeless) => {
    if (provider === Providers.CoverWhale)
      return getCoverwhaleCalculation(quote, feeless);

    if (provider === Providers.Progressive)
      return getProgressiveCalculation(quote, feeless);
  };
  generateQuotePDFBlob = async (data) =>
    await pdf(<QuotePDF data={data} />).toBlob();
}

export default QuoteUtils;
